import jwt from 'jsonwebtoken';

export const decodeToken = (token = '') =>
  jwt.decode(token, { complete: false }) as jwt.JwtPayload | null;
